import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-service-item-cancel',
  standalone: true,
  imports: [],
  templateUrl: './service-item-cancel.component.html',
  styleUrl: './service-item-cancel.component.scss'
})
export class ServiceItemCancelComponent {

  public view : any = {
    // service: {
    //   supplier: '',
    //   service: '',
    //   cost: null,
    //   exchangeRateCurrent: null,
    //   price: null,
    //   start: null,
    //   end: null,
    //   adultCount: null,
    //   teenCount: null,
    //   childCount: null,
    //   infantCount: null,
    //   internalNote: '',
    //   chk1: false
    // }
  };

  constructor(public tfmService: TFMService,public dialogRef: MatDialogRef<ServiceItemCancelComponent>, @Inject(MAT_DIALOG_DATA) public data:any,private dialog: MatDialog){
    this.view.service = this.data

  }
  cancelServiceItem() {
    if (this.view.service) {
      //console.log("Cancel service item", this.view.service);

      this.tfmService.filterAndSend(this.view.service._links, "cancel", this.view.service).subscribe(res => {
        console.log("Service cancel sent, please confirm");
        this.dialogRef.close();
        this.openConfirmationModal({
          title: 'Service Canceled',
          message: 'The service has been canceled successfully',
          showClose: true,
          showViewQuotes: false,
          showNewQuote: false
        });

        // this.itinOptionsLoad();
      });
    }
  }
  close(): void {
    this.dialogRef.close();
  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
        this.dialog.open(ConfirmationDialogComponent, {
          data: config
        });
      }

}
